import { ProductVariant, VariantType } from 'api/products/_requests';
import React, { useState } from 'react';
import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import { Trash } from 'feather-icons-react';
import { colors, sizes, weights } from './model';
import Dropzone from 'components/base/Dropzone';
import ReactSelect from 'components/base/ReactSelect';

export type SelectOption = {
  value: string;
  label: string;
};

interface ProductVariantFormProps {
  variants: ProductVariant[];
  setVariants: (variants: ProductVariant[]) => void;
  variantTypes: VariantType[];
  setVariantTypes: (variantTypes: VariantType[]) => void;
  selectedColors: SelectOption[];
  setSelectedColors: (selectedColors: SelectOption[]) => void;
  selectedSize: SelectOption[];
  setSelectedSize: (selectedSize: SelectOption[]) => void;
  selectedWeight: SelectOption[];
  setSelectedWeight: (selectedWeight: SelectOption[]) => void;
}

const ProductVariantTypeForm = ({
  variants,
  setVariants,
  variantTypes,
  setVariantTypes,
  selectedColors,
  setSelectedColors,
  selectedSize,
  setSelectedSize,
  selectedWeight,
  setSelectedWeight
}: ProductVariantFormProps) => {
  const handleRemoveVariant = (index: number) => {
    setVariantTypes(variantTypes.filter((_, i) => i !== index));
  };

  const colorOptions = Object.entries(colors).map(([name, hex]) => ({
    value: name,
    label: name?.charAt(0).toUpperCase() + name?.slice(1),
    hex
  }));

  const sizeOptions = Object.entries(sizes).map(([key]) => ({
    value: key,
    label: key?.toUpperCase()
  }));

  const weightOptions = Object.entries(weights).map(([key]) => ({
    value: key,
    label: key?.toUpperCase()
  }));

  const handleSelectedColors = (selectedColors: SelectOption[]) => {
    setSelectedColors(selectedColors);
  };

  const handleSelectedSize = (selectedSize: SelectOption[]) => {
    setSelectedSize(selectedSize);
  };

  const handleSelectedWeight = (selectedWeight: SelectOption[]) => {
    setSelectedWeight(selectedWeight);
  };

  return (
    <div className="d-flex flex-wrap justify-content-start gap-3 mb-3">
      {variantTypes.map((variantType, index) => (
        <Card key={index} className="shadow-sm w-md-30 w-100">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">Variant Type {index + 1}</h4>
              <Button
                variant="danger"
                size="sm"
                onClick={() => handleRemoveVariant(index)}
                className="d-flex align-items-center gap-1"
              >
                <Trash size={16} />
              </Button>
            </div>
            <Form>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Variant Type</Form.Label>
                    <Form.Select
                      value={variantType}
                      onChange={e =>
                        setVariantTypes(
                          variantTypes.map((type, i) =>
                            i === index ? (e.target.value as VariantType) : type
                          )
                        )
                      }
                    >
                      <option
                        value="color"
                        disabled={variantTypes.includes('color')}
                      >
                        Color
                      </option>
                      <option
                        value="size"
                        disabled={variantTypes.includes('size')}
                      >
                        Size
                      </option>
                      <option
                        value="weight"
                        disabled={variantTypes.includes('weight')}
                      >
                        Weight
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>Variant Value</Form.Label>
                    {variantType === 'color' ? (
                      <ReactSelect
                        options={colorOptions}
                        isMulti
                        placeholder="Select colors"
                        value={selectedColors}
                        onChange={e =>
                          handleSelectedColors(e as SelectOption[])
                        }
                      />
                    ) : variantType === 'size' ? (
                      <ReactSelect
                        options={sizeOptions}
                        isMulti
                        placeholder="Select sizes"
                        value={selectedSize}
                        onChange={e => handleSelectedSize(e as SelectOption[])}
                      />
                    ) : variantType === 'weight' ? (
                      <ReactSelect
                        options={weightOptions}
                        isMulti
                        placeholder="Select weights"
                        value={selectedWeight}
                        onChange={e =>
                          handleSelectedWeight(e as SelectOption[])
                        }
                      />
                    ) : null}
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default ProductVariantTypeForm;
